import styles from "./jobs.module.css";
import headerImage from "./job.jpg";
import Title from "../../components/title";
import { useState } from "react";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";

const PreJob = () => {
  const [breadCrumb] = useState([
    { title: "خانه", url: "/" },
    { title: "دعوت به همکاری", url: "/job/intro" },
  ]);
  return (
    <div className="container">
      <Title title={"دعوت به همکاری"} />
      <BreadCrumb items={breadCrumb} />
      <div className={styles.preJobWrapper}>
        <div className={styles.preJobImageContainer}>
          <img src={headerImage} />
        </div>
        <div className={styles.preJobContent}>
          <p>
            شرکت خدمات انفورماتیک بزرگترین شرکت فعال در زمینه فناوری اطلاعات،
            مجری طرح جامع اتوماسیون بانکی کشور، همواره سعی نموده است با بهره
            گیری مناسب از نیروهای متخصص، متعهد و با تجربه، اندوخته ارزشمندی را
            برای خود کسب نماید.
          </p>
          <p>
            لذا این شرکت در نظر دارد به منظور تامین و تکمیل سرمایه انسانی مورد
            نیاز خود، از واجدین شرایط پس از ثبت نام الکترونیکی و بر اساس اولویت
            های مورد نیاز، در شهر تهران دعوت به همکاری نماید.
          </p>
          <p>
            در صورت نیاز به راهنمایی و یا پرسش در مورد استخدام و پیگیری مراحل آن
            می توانید از طریق ایمیل
            <strong>Talentpool@isc.co.ir</strong>و همچنین در صورت بروز مشکل فنی
            در خصوص فرم دعوت به همکاری می توانید از طریق ایمیل
            <strong>ITSupport@isc.co.ir</strong>و یا شماره تماس ۷۲۳۵۱۵۰۰ در
            ساعات اداری با ما در ارتباط باشید .
          </p>
        </div>
        <div className={styles.buttonRow}>
          <a
            href={"https://job.isc.co.ir"}
            className={styles.link}
            target="_blank"
          >
            شروع ثبت رزومه
            <i className="fa fa-angle-left"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PreJob;
